import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const RUBRIC = [
    { key: "alliance_rapport",       slug: "alliance-rapport",       label: "Therapeutic Alliance & Rapport" },
    { key: "listening_reflection",   slug: "listening-reflection",   label: "Active Listening & Reflection" },
    { key: "technique_application",  slug: "technique-application",  label: "Technique Selection & Application" },
    { key: "case_conceptualisation", slug: "case-conceptualisation", label: "Case Conceptualisation" },
    { key: "flexibility_blending",   slug: "flexibility-blending",   label: "Flexibility & Therapeutic Blending" },
    { key: "humanism_humour",        slug: "humanism-humour",        label: "Humanism, Warmth & Humour" },
    { key: "pacing_silence",         slug: "pacing-silence",         label: "Pacing, Timing & Use of Silence" },
    { key: "outcome_movement",       slug: "outcome-movement",       label: "Outcome Movement & Client Engagement" },
];

/**
 * Score breakdown bar list. Renders the 8 rubric categories with a
 * fill bar, the score numerator, and the supervisor's one-sentence note.
 * Falls back to nothing if the review predates Phase 12.
 */
export const ScoreBreakdownCard = ({ breakdown }) => {
    if (!breakdown || typeof breakdown !== "object") return null;
    return (
        <Card className="border-border/80 shadow-sm" data-testid="review-score-breakdown-card">
            <CardContent className="p-6 space-y-5">
                <div>
                    <h3 className="text-base font-semibold text-foreground">How this score breaks down</h3>
                    <p className="mt-1 text-xs text-muted-foreground">
                        Eight rubric categories that sum to your total.
                    </p>
                </div>
                <ul className="space-y-5">
                    {RUBRIC.map(({ key, slug, label }) => {
                        const row = breakdown[key];
                        if (!row) return null;
                        const score = Number(row.score ?? 0);
                        const max = Number(row.max ?? 0) || 1;
                        const pct = Math.max(0, Math.min(100, (score / max) * 100));
                        return (
                            <li
                                key={key}
                                className="space-y-1.5"
                                data-testid={`score-breakdown-${slug}`}
                            >
                                <div className="flex items-baseline justify-between gap-3">
                                    <span className="text-sm font-medium text-foreground">{label}</span>
                                    <span className="text-xs tabular-nums text-muted-foreground">
                                        <span className="font-semibold text-foreground">{score}</span>
                                        /{max}
                                    </span>
                                </div>
                                <div
                                    className="h-2 w-full overflow-hidden rounded-full bg-secondary"
                                    role="progressbar"
                                    aria-valuenow={score}
                                    aria-valuemin={0}
                                    aria-valuemax={max}
                                    aria-label={label}
                                >
                                    <div
                                        className="h-full rounded-full bg-primary transition-all"
                                        style={{ width: `${pct}%` }}
                                    />
                                </div>
                                {row.note && (
                                    <p className="text-xs leading-relaxed text-muted-foreground">
                                        {row.note}
                                    </p>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </CardContent>
        </Card>
    );
};
